import React from "react"
import mount from "core/mount"
import Button from "@kit/design/button"
import Note from "@kit/design/note"

function UnconfirmedUserEmailBanner({ emailSettingsLink }) {
  return (
    <Note type="warning" size="sm" className="!bg-system-yellow-100">
      <p className="flex-grow">
        <strong>Confirm your email to finish setting up your account.</strong>{" "}
        We&apos;ve sent a confirmation link to your sign-up address.
      </p>
      <Button
        is="plain"
        size="sm"
        href={emailSettingsLink}
        target="_blank"
        className="ml-4 flex-shrink-0 bg-system-yellow-400 hover:bg-system-yellow-500"
      >
        Manage email address
      </Button>
    </Note>
  )
}

export { UnconfirmedUserEmailBanner }

mount({ "Account.UnconfirmedUserEmailBanner": UnconfirmedUserEmailBanner })
